import React from 'react';

// Components

import Tooltip from '@components/common/tooltip/Tooltip';

export const STUDENT_LOAN_INTEREST_AMOUNT_TOOLTIP_CONTENT = {
    DEDUCTION: 'ssap.income_information.deductions.student_loan_interest_amount.tooltip',
    EXPECTED_INCOME: 'ssap.income_information.expected_income.student_loan_interest_amount.tooltip',
};

const StudentLoanInterestAmountTooltip = props => {
    const {
        content,
        index,
        dataAutomationId,
    } = props;

    return (
        <Tooltip
            id=''
            content={content}
            index={index}
            icon='info-circle'
            triggerDecorationClassName=''
            triggerClassName='margin-l-5'
            multiline
            dataAutomationId={dataAutomationId}
        />
    );
};

export default StudentLoanInterestAmountTooltip;
